import React, { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import DependentEntitiesSelector, { commonPropTypes } from "./dependent-entities-selector";

const query = `
  query EventTypes($contractId: ID, $offset: Int, $limit: Int) {
    eventTypes(contractId: $contractId, offset: $offset, limit: $limit) {
      items {
        id
        name
        description
      }
      total
    }
  }
`;

const EventTypeSelect = ({ id = "typeId", name = "typeId", contractId, isInsideForm, onChange, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.eventTypes, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.description, []);

  const [dependencyId, setDependencyId] = useState(contractId);

  useEffect(
    () => {
      if (contractId !== dependencyId) {
        setDependencyId(contractId);
        if (!contractId) {
          onChange(name)(undefined);
        }
      }
    },
    [contractId, dependencyId, name, onChange, props.value],
  );

  return (
    <DependentEntitiesSelector
      disabled={!contractId}
      queryParams={{
        contractId,
      }}
      skip={!contractId}
      isInsideForm={isInsideForm}
      multiple={false}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      onChange={onChange}
      {...props}
    />
  );
};

EventTypeSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Contrato para el que se mostrarán los tipos de evento
   */
  contractId: PropTypes.string,
};

export default EventTypeSelect;
